import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

export const HeroAnimation = ({
    lottiePlayer,
    src,
    ...rest
}) => {

    return (
        <div className="lottie-player-wrapper">
            <Player
                autoplay
                ref={lottiePlayer}
                src={src}
                style={{ height: '100%', width: '100%' }}
                {...rest}
            />
        </div>
    );
};
